import React from "react";

export const CanadaFlagIcon = React.forwardRef<
  SVGSVGElement,
  React.ComponentPropsWithoutRef<"svg">
>(({ ...props }, ref) => (
  <svg
    {...props}
    ref={ref}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_260_1792)">
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#F0F0F0"
      />
      <path
        d="M16.0005 8.00062C16.0005 4.82893 14.1547 2.08843 11.4788 0.794434V15.2068C14.1547 13.9128 16.0005 11.1723 16.0005 8.00062Z"
        fill="#D80027"
      />
      <path
        d="M0.000244141 8.00013C0.000244141 11.1718 1.84603 13.9123 4.52199 15.2063V0.793945C1.84603 2.08795 0.000244141 4.82844 0.000244141 8.00013Z"
        fill="#D80027"
      />
      <path
        d="M9.39168 9.04417L10.783 8.34851L10.0873 8.0007V7.30504L8.69602 8.0007L9.39168 6.60939H8.69602L8.00037 5.56592L7.30471 6.60939H6.60905L7.30471 8.0007L5.9134 7.30504V8.0007L5.21777 8.34851L6.60905 9.04417L6.26124 9.73982H7.65255V10.7833H8.34818V9.73982H9.73949L9.39168 9.04417Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_260_1792">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

CanadaFlagIcon.displayName = "CanadaFlagIcon";

export const UsFlagIcon = React.forwardRef<
  SVGSVGElement,
  React.ComponentPropsWithoutRef<"svg">
>(({ ...props }, ref) => (
  <svg
    {...props}
    ref={ref}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_260_1144)">
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.65186 8.00005H15.9997C15.9997 7.27799 15.9034 6.57849 15.7241 5.91309H7.65186V8.00005Z"
        fill="#D80027"
      />
      <path
        d="M7.65186 3.82574H14.8255C14.3358 3.02661 13.7096 2.32027 12.9795 1.73877H7.65186V3.82574Z"
        fill="#D80027"
      />
      <path
        d="M7.99977 15.9999C9.88255 15.9999 11.6131 15.3491 12.9796 14.2607H3.0199C4.38646 15.3491 6.11699 15.9999 7.99977 15.9999Z"
        fill="#D80027"
      />
      <path
        d="M1.17398 12.1734H14.8256C15.2188 11.5319 15.5237 10.8306 15.7242 10.0864H0.275391C0.475922 10.8306 0.780828 11.5319 1.17398 12.1734Z"
        fill="#D80027"
      />
      <path
        d="M3.70575 1.24931H4.43478L3.75666 1.74197L4.01569 2.53912L3.33759 2.04647L2.6595 2.53912L2.88325 1.85047C2.28619 2.34781 1.76287 2.9305 1.33162 3.57975H1.56522L1.13356 3.89334C1.06631 4.00553 1.00181 4.1195 0.94 4.23516L1.14612 4.86956L0.761563 4.59016C0.665969 4.79269 0.578531 4.99978 0.499938 5.21119L0.727031 5.91019H1.56522L0.887094 6.40284L1.14612 7.2L0.468031 6.70734L0.0618437 7.00247C0.0211875 7.32928 0 7.66216 0 8H8C8 3.58175 8 3.06087 8 0C6.41963 0 4.94641 0.458438 3.70575 1.24931ZM4.01569 7.2L3.33759 6.70734L2.6595 7.2L2.91853 6.40284L2.24041 5.91019H3.07859L3.33759 5.11303L3.59659 5.91019H4.43478L3.75666 6.40284L4.01569 7.2ZM3.75666 4.07241L4.01569 4.86956L3.33759 4.37691L2.6595 4.86956L2.91853 4.07241L2.24041 3.57975H3.07859L3.33759 2.78259L3.59659 3.57975H4.43478L3.75666 4.07241ZM6.88525 7.2L6.20716 6.70734L5.52906 7.2L5.78809 6.40284L5.10997 5.91019H5.94816L6.20716 5.11303L6.46616 5.91019H7.30434L6.62622 6.40284L6.88525 7.2ZM6.62622 4.07241L6.88525 4.86956L6.20716 4.37691L5.52906 4.86956L5.78809 4.07241L5.10997 3.57975H5.94816L6.20716 2.78259L6.46616 3.57975H7.30434L6.62622 4.07241ZM6.62622 1.74197L6.88525 2.53912L6.20716 2.04647L5.52906 2.53912L5.78809 1.74197L5.10997 1.24931H5.94816L6.20716 0.452156L6.46616 1.24931H7.30434L6.62622 1.74197Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_260_1144">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

UsFlagIcon.displayName = "UsFlagIcon";

export const EuFlagIcon = React.forwardRef<
  SVGSVGElement,
  React.ComponentPropsWithoutRef<"svg">
>(({ ...props }, ref) => (
  <svg
    {...props}
    ref={ref}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_260_1534)">
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#338AF3"
      />
      <path
        d="M8.00014 3.47852L8.34545 4.54139H9.46308L8.55895 5.1983L8.90427 6.26114L8.00014 5.60427L7.09598 6.26114L7.44139 5.1983L6.53723 4.54139H7.65483L8.00014 3.47852Z"
        fill="#F0F0F0"
      />
      <path
        d="M3.47827 8.00011L4.54115 7.65474V6.53711L5.19805 7.4413L6.2609 7.09595L5.60402 8.00011L6.2609 8.90418L5.19805 8.5588L4.54115 9.46296V8.34539L3.47827 8.00011Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.0002 12.5224L7.65486 11.4595H6.53723L7.44142 10.8026L7.09608 9.73975L8.0002 10.3966L8.9043 9.73975L8.55892 10.8026L9.46308 11.4595H8.34552L8.0002 12.5224Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.522 8.00002L11.4591 8.34536V9.46296L10.8022 8.5588L9.73938 8.90414L10.3963 8.00002L9.73938 7.09592L10.8022 7.4413L11.4591 6.53711V7.65471L12.522 8.00002Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_260_1534">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

EuFlagIcon.displayName = "EuFlagIcon";

export const GlobeIcon = React.forwardRef<
  SVGSVGElement,
  React.ComponentPropsWithoutRef<"svg">
>(({ ...props }, ref) => (
  <svg
    {...props}
    ref={ref}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_260_1554)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C12.418 0 16 3.58203 16 8C16 12.418 12.418 16 8 16C3.58203 16 0 12.418 0 8C0 3.58203 3.58203 0 8 0Z"
        fill="#2394E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.53137 12.133C1.06002 11.4181 0.707153 10.6174 0.500122 9.75928L1.90898 10.439L1.91679 10.8595C1.91679 11.0145 1.65377 11.3426 1.56913 11.4676L1.53137 12.133ZM10.1967 0.846517C12.8816 1.73844 14.896 4.10173 15.284 6.97933L15.0301 6.95199C14.9845 7.1473 14.9428 7.15121 14.9428 7.38558C14.9428 7.59261 15.2032 7.73063 15.2032 8.16683C15.2032 8.28402 14.9285 8.51709 14.9168 8.55876L14.5092 8.08089V8.68897L14.448 8.68636L14.3387 7.56397L14.1108 7.63558L13.84 6.80094L12.948 7.73324L12.9376 8.41553L12.646 8.61084L12.3361 6.86084L12.1512 6.99626L11.7319 6.42985L11.1056 6.44808L10.866 6.17334L10.6199 6.24105L10.1368 5.68766L10.0431 5.75147L10.3426 6.51709H10.6902V6.34391H10.8634C10.9884 6.69027 11.1238 6.48454 11.1238 6.69157C11.1238 7.41423 10.2319 7.94548 9.64726 8.08089C9.67851 8.2111 9.66679 8.34131 9.82043 8.34131C10.1473 8.34131 9.9845 8.28402 10.3413 8.25407C10.3243 8.99235 9.49491 9.87386 9.14075 10.422L9.2996 11.5535C9.34127 11.7996 8.78918 12.0588 8.60168 12.3361L8.69153 12.7697L8.43762 12.8726C8.39335 13.3179 7.96106 13.8114 7.47538 13.8114H6.95455C6.95455 13.202 6.51965 12.3309 6.51965 11.8999C6.51965 11.534 6.69283 11.4845 6.69283 11.0314C6.69283 10.6121 6.25924 10.0119 6.25924 9.90251V9.20719H5.91158C5.8595 9.01318 5.89205 8.94678 5.65116 8.94678H5.56392C5.18502 8.94678 5.24882 9.11996 4.86861 9.11996H4.52096C4.20715 9.11996 3.65247 8.11475 3.65247 7.99105V6.94938C3.65247 6.50016 4.06392 6.01058 4.34778 5.82048V5.38688L4.7384 4.98975L4.95585 4.95329C5.422 4.95329 5.36601 4.69287 5.65116 4.69287H6.43241V5.30094L7.29179 5.66813L7.37252 5.29704C7.76184 5.38818 7.8634 5.56136 8.34257 5.56136H8.51575C8.84517 5.56136 8.8634 5.12386 8.8634 4.78011L8.16809 4.84912L7.86471 4.19027L7.56392 4.26969C7.61861 4.50537 7.64726 4.40772 7.64726 4.60693C7.64726 4.72412 7.5509 4.73714 7.47278 4.78011L7.172 4.01709L6.52486 3.55485L6.43892 3.63949L6.98971 4.21891C6.91679 4.42725 6.90767 5.02751 6.60429 4.60693L6.88814 4.47022L6.17981 3.72803L5.75533 3.89339L5.33606 4.29443C5.29179 4.61735 5.20455 4.78011 4.86601 4.78011C4.64075 4.78011 4.77616 4.72152 4.43111 4.69287V3.82438H5.21236L4.95846 3.24626L4.86471 3.30355V3.12907L6.13424 2.54443C6.1108 2.36214 6.08085 2.4598 6.08085 2.26058C6.08085 2.24886 6.16549 2.0887 6.16809 2.0861L6.49622 2.29053L6.41809 1.91683L5.91158 2.021L5.81783 1.56657C6.21887 1.35563 7.10299 0.61084 7.38424 0.61084H7.64465C7.91939 0.61084 8.65377 0.881673 8.77356 1.04443L8.07694 0.974121L8.59387 1.3999L8.64335 1.21761L9.02877 1.11214L9.03398 0.871257H9.20846V1.13167L10.1967 0.846517Z"
        fill="#A1E367"
      />
    </g>
    <defs>
      <clipPath id="clip0_260_1554">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

GlobeIcon.displayName = "GlobeIcon";
